
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Basetheme = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        let current_language = document.documentElement.lang;

        if (current_language === 'en-GB') {
            current_language = 'en';
        }

        if ( $('.block__sgmatrix').length > 0 || $('.block_carbonneutrality').length > 0 || $('.block_esghandbook').length > 0 || $('.block__mailchimp').length > 0 ) {
            $('#footer-newsletter').remove();
        }

        /**
         * Generate the field validity object
         * @param  {Node]} field The field to validate
         * @return {Object}      The validity object
         */
        var getValidityState = function(field) {

            // Variables
            var type = field.getAttribute('type') || input.nodeName.toLowerCase();
            var isNum = type === 'number' || type === 'range';
            var length = field.value.length;
            var valid = true;

            // If radio group, get selected field
            if (field.type === 'radio' && field.name) {
                var group = document.getElementsByName(field.name);
                if (group.length > 0) {
                    for (var i = 0; i < group.length; i++) {
                        if (group[i].form === field.form && field.checked) {
                            field = group[i];
                            break;
                        }
                    }
                }
            }

            // If radio group, get selected field
            if (field.type === 'checkbox' && field.name) {
                var cgroup = document.getElementsByName(field.name);
                if (cgroup.length > 0) {
                    for (var c = 0; c < cgroup.length; c++) {
                        if (cgroup[c].form === field.form && field.checked) {
                            field = cgroup[c];
                            break;
                        }
                    }
                }
            }

            // Run validity checks
            var checkValidity = {
                badInput: (isNum && length > 0 && !/[-+]?[0-9]/.test(field.value)), // value of a number field is not a number
                patternMismatch: (field.hasAttribute('pattern') && length > 0 && new RegExp(field.getAttribute('pattern')).test(field.value) === false), // value does not conform to the pattern
                rangeOverflow: (field.hasAttribute('max') && isNum && field.value > 0 && Number(field.value) > Number(field.getAttribute('max'))), // value of a number field is higher than the max attribute
                rangeUnderflow: (field.hasAttribute('min') && isNum && field.value > 0 && Number(field.value) < Number(field.getAttribute('min'))), // value of a number field is lower than the min attribute
                stepMismatch: (isNum && ((field.hasAttribute('step') && field.getAttribute('step') !== 'any' && Number(field.value) % Number(field.getAttribute('step')) !== 0) || (!field.hasAttribute('step') && Number(field.value) % 1 !== 0))), // value of a number field does not conform to the stepattribute
                tooLong: (field.hasAttribute('maxLength') && field.getAttribute('maxLength') > 0 && length > parseInt(field.getAttribute('maxLength'), 10)), // the user has edited a too-long value in a field with maxlength
                tooShort: (field.hasAttribute('minLength') && field.getAttribute('minLength') > 0 && length > 0 && length < parseInt(field.getAttribute('minLength'), 10)), // the user has edited a too-short value in a field with minlength
                typeMismatch: (length > 0 && ((type === 'email' && !/^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(field.value)) || (type === 'url' && !/^(?:(?:https?|HTTPS?|ftp|FTP):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]-*)*[a-zA-Z\u00a1-\uffff0-9]+)*)(?::\d{2,5})?(?:[\/?#]\S*)?$/.test(field.value)))), // value of a email or URL field is not an email address or URL
                valueMissing: (field.hasAttribute('required') && (((type === 'checkbox' || type === 'radio') && !field.checked) || (type === 'select' && field.options[field.selectedIndex].value < 1) || (type !== 'checkbox' && type !== 'radio' && type !== 'select' && length < 1))) // required field without a value
            };

            // Check if any errors
            for (var key in checkValidity) {
                if (checkValidity.hasOwnProperty(key)) {
                    // If there's an error, change valid value
                    if (checkValidity[key]) {
                        valid = false;
                        break;
                    }
                }
            }

            // Add valid property to validity object
            checkValidity.valid = valid;

            // Return object
            return checkValidity;

        };

        // Add the novalidate attribute when the JS loads
        var forms = document.querySelectorAll('.validate');
        for (var i = 0; i < forms.length; i++) {
            forms[i].setAttribute('novalidate', true);
        }

        // Validate the field
        var hasError = function(field) {

            // Don't validate submits, buttons, file and reset inputs, and disabled fields
            if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') { return; }

            // Get validity
            var validity = field.validity;

            // If valid, return null
            if (validity.valid) { return; }

            if ( current_language === 'en' ) {

                // If field is required and empty
                if (validity.valueMissing) { return 'Please fill out this field.'; }

                // If not the right type
                if (validity.typeMismatch) {

                    // Email
                    if (field.type === 'email') { return 'Please enter an email address.'; }

                    // URL
                    if (field.type === 'url') { return 'Please enter a URL.'; }

                }

                // If too short
                if (validity.tooShort) { return 'Please lengthen this text to ' + field.getAttribute('minLength') + ' characters or more. You are currently using ' + field.value.length + ' characters.'; }

                // If too long
                if (validity.tooLong) { return 'Please shorten this text to no more than ' + field.getAttribute('maxLength') + ' characters. You are currently using ' + field.value.length + ' characters.'; }

                // If pattern doesn't match
                if (validity.patternMismatch) {

                    // If pattern info is included, return custom error
                    if (field.hasAttribute('title')) { return field.getAttribute('title'); }

                    // Otherwise, generic error
                    return 'Please match the requested format.';

                }

                // If number input isn't a number
                if (validity.badInput) { return 'Please enter a number.'; }

                // If a number value doesn't match the step interval
                if (validity.stepMismatch) { return 'Please select a valid value.'; }

                // If a number field is over the max
                if (validity.rangeOverflow) { return 'Please select a value that is no more than ' + field.getAttribute('max') + '.'; }

                // If a number field is below the min
                if (validity.rangeUnderflow) { return 'Please select a value that is no less than ' + field.getAttribute('min') + '.'; }

                // If all else fails, return a generic catchall error
                return 'The value you entered for this field is invalid.';

            } else {

                // If field is required and empty
                if (validity.valueMissing) { return 'Tämä kenttä on pakollinen.'; }

                // If not the right type
                if (validity.typeMismatch) {

                    // Email
                    if (field.type === 'email') { return 'Syötä oikea sähköpostiosoite.'; }

                }

                // If all else fails, return a generic catchall error
                return 'Annettu arvo on virheellinen.';
            }

        };

        // Show an error message
        var showError = function(field, error) {

            // Add error class to field
            field.classList.add('error');

            // If the field is a radio button and part of a group, error all and get the last item in the group
            if (field.type === 'radio' && field.name) {
                var group = field.form.querySelectorAll('[name="' + field.name + '"]');
                if (group.length > 0) {
                    for (var i = 0; i < group.length; i++) {
                        group[i].classList.add('error');
                    }
                    field = group[group.length - 1];
                }
            }

            if (field.type === 'checkbox' && field.name) {
                var cgroup = field.form.querySelectorAll('[name="' + field.name + '"]');
                if (cgroup.length > 0) {
                    for (var c = 0; c < cgroup.length; c++) {
                        cgroup[c].classList.add('error');
                    }
                    field = cgroup[cgroup.length - 1];
                }
            }

            // Get field id or name
            var id = field.id || field.name;
            if (!id) { return; }

            // Check if error message field already exists
            // If not, create one
            var message = field.form.querySelector('.mce_inline_error#error-for-' + id);
            if (!message) {
                message = document.createElement('div');
                message.className = 'mce_inline_error';
                message.id = 'error-for-' + id;

                // If the field is a radio button or checkbox, insert error after the label
                var label;
                if (field.type === 'radio' || field.type === 'checkbox') {
                    label = field.form.querySelector('label[for="' + id + '"]') || field.parentNode;
                    if (label) {
                        label.parentNode.insertBefore(message, label.nextSibling);
                    }
                }

                // Otherwise, insert it after the field
                if (!label) {
                    field.parentNode.insertBefore(message, field.nextSibling);
                }

            }

            // Add ARIA role to the field
            field.setAttribute('aria-describedby', 'error-for-' + id);

            // Update error message
            message.innerHTML = error;

            // Show error message
            message.style.display = 'block';
            message.style.visibility = 'visible';

        };

        // Remove the error message
        var removeError = function(field) {

            // Remove error class to field
            field.classList.remove('error');

            // Remove ARIA role from the field
            field.removeAttribute('aria-describedby');

            // If the field is a radio button and part of a group, remove error from all and get the last item in the group
            if (field.type === 'radio' && field.name) {
                var group = field.form.querySelectorAll('[name="' + field.name + '"]');
                if (group.length > 0) {
                    for (var i = 0; i < group.length; i++) {
                        group[i].classList.remove('error');
                    }
                    field = group[group.length - 1];
                }
            }

            // If the field is a radio button and part of a group, remove error from all and get the last item in the group
            if (field.type === 'checkbox' && field.name) {
                var cgroup = field.form.querySelectorAll('[name="' + field.name + '"]');
                if (cgroup.length > 0) {
                    for (var c = 0; c < cgroup.length; c++) {
                        cgroup[c].classList.remove('error');
                    }
                    field = cgroup[cgroup.length - 1];
                }
            }

            // Get field id or name
            var id = field.id || field.name;
            if (!id) { return; }


            // Check if an error message is in the DOM
            var message = field.form.querySelector('.mce_inline_error#error-for-' + id + '');
            if (!message) { return; }

            // If so, hide it
            message.innerHTML = '';
            message.style.display = 'none';
            message.style.visibility = 'hidden';

        };

        // Serialize the form data into a query string
        // Forked and modified from https://stackoverflow.com/a/30153391/1293256
        var serialize = function(form) {

            // Setup our serialized data
            var serialized = '';

            // Loop through each field in the form
            for (i = 0; i < form.elements.length; i++) {

                var field = form.elements[i];

                // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
                if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') { continue; }

                // Convert field data to a query string
                if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                    serialized += '&' + encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
                }
            }

            return serialized;

        };

        function onSubmitSG(token) {

            var targetforms = document.getElementsByClassName('sgmatrix-form');
            var targetform = targetforms[0];

            var fields = targetform.elements;

            // Validate each field
            // Store the first field with an error to a variable so we can bring it into focus later
            var error, hasErrors;
            for (var i = 0; i < fields.length; i++) {
                error = hasError(fields[i]);
                if (error) {
                    showError(fields[i], error);
                    if (!hasErrors) {
                        hasErrors = fields[i];
                    }
                }
            }

            // If there are errrors, don't submit form and focus on first element with error
            if (hasErrors) {
                hasErrors.focus();
            }

            $('#mce-error-response').hide();

            var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            var session_id = '';
            for (var z = 0; z < 16; z++) {
                session_id += chars[Math.floor(Math.random() * chars.length)];
            }

            var freq = '';
            var list_id = $('.sgmatrix-form').data('list');
            var lang = $('.sgmatrix-form').data('lang');

            // console.log(list_id);

            if ( $('#mce-FREQUENCY-2').is(":checked") ) {
                freq = $('#mce-FREQUENCY-2').val();
            }
            // submit the form using AJAX
            $.ajax({
              type: 'POST',
              url : TesiAjax.ajax_url,
              data: {
                action: 'custom_subscribe_sg', // specify the AJAX action
                session_id: session_id,
                email: $('#mce-EMAIL').val(),
                fname: $('#mce-FNAME').val(),
                lname: $('#mce-LNAME').val(),
                company: $('#mce-COMPANY').val(),
                token: token,
                lang: lang,
                list_id: list_id,
                frequency: freq
                // tags: $("input[name=tags]").val()
              },
              dataType: 'json',
              success: function(response) {
                if (response.result === 'success') {
                    if ( response.score > 0.4 ) {
                        if ( current_language === 'en' ) {
                            window.location.href = '/en/sustainability/sg-matrix-download/?submission=' + session_id;
                        } else {
                            window.location.href = '/kestavyys/sg-matriisi-tiedostolataus/?submission=' + session_id;
                        }
                    } else {
                        $('#mce-error-response').html(response.msg).show();
                    }
                } else {
                  // handle the error
                  $('#mce-error-response').html(response.msg).show();
                }
              }
            });
        }

        window.onSubmitSG = onSubmitSG;

        function onSubmitCF(token) {

            var targetforms = document.getElementsByClassName('carbon-neutrality-form');
            var targetform = targetforms[0];

            var fields = targetform.elements;

            // Validate each field
            // Store the first field with an error to a variable so we can bring it into focus later
            var error, hasErrors;
            for (var i = 0; i < fields.length; i++) {
                error = hasError(fields[i]);
                if (error) {
                    showError(fields[i], error);
                    if (!hasErrors) {
                        hasErrors = fields[i];
                    }
                }
            }

            // If there are errrors, don't submit form and focus on first element with error
            if (hasErrors) {
                hasErrors.focus();
            }

            $('#mce-error-response').hide();

            var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            var session_id = '';
            for (var z = 0; z < 16; z++) {
                session_id += chars[Math.floor(Math.random() * chars.length)];
            }

            var freq = '';
            var list_id = $('.carbon-neutrality-form').data('list');
            var lang = $('.carbon-neutrality-form').data('lang');

            // console.log(list_id);

            if ( $('#mce-FREQUENCY-2').is(":checked") ) {
                freq = $('#mce-FREQUENCY-2').val();
            }
            // submit the form using AJAX
            $.ajax({
              type: 'POST',
              url : TesiAjax.ajax_url,
              data: {
                action: 'custom_subscribe_cf', // specify the AJAX action
                session_id: session_id,
                email: $('#mce-EMAIL').val(),
                fname: $('#mce-FNAME').val(),
                lname: $('#mce-LNAME').val(),
                company: $('#mce-COMPANY').val(),
                token: token,
                lang: lang,
                list_id: list_id,
                frequency: freq
                // tags: $("input[name=tags]").val()
              },
              dataType: 'json',
              success: function(response) {
                if (response.result === 'success') {
                    if ( response.score > 0.4 ) {
                        if ( current_language === 'en' ) {
                            window.location.href = '/en/sustainability/carbon-neutrality-downloads/?submission_cf=' + session_id;
                        } else {
                            window.location.href = '/kestavyys/hiilineutraalisuusmateriaalit/?submission_cf=' + session_id;
                        }
                    } else {
                        $('#mce-error-response').html(response.msg).show();
                    }
                } else {
                  // handle the error
                  $('#mce-error-response').html(response.msg).show();
                }
              }
            });
        }

        window.onSubmitCF = onSubmitCF;

        function onSubmitHB(token) {

            var targetforms = document.getElementsByClassName('esg-handbook-form');
            var targetform = targetforms[0];

            var fields = targetform.elements;

            // Validate each field
            // Store the first field with an error to a variable so we can bring it into focus later
            var error, hasErrors;
            for (var i = 0; i < fields.length; i++) {
                error = hasError(fields[i]);
                if (error) {
                    showError(fields[i], error);
                    if (!hasErrors) {
                        hasErrors = fields[i];
                    }
                }
            }

            // If there are errrors, don't submit form and focus on first element with error
            if (hasErrors) {
                hasErrors.focus();
            }

            $('#mce-error-response').hide();

            var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            var session_id = '';
            for (var z = 0; z < 16; z++) {
                session_id += chars[Math.floor(Math.random() * chars.length)];
            }

            var freq = '';
            var list_id = $('.esg-handbook-form').data('list');
            var lang = $('.esg-handbook-form').data('lang');

            // console.log(list_id);

            if ( $('#mce-FREQUENCY-2').is(":checked") ) {
                freq = $('#mce-FREQUENCY-2').val();
            }
            // submit the form using AJAX
            $.ajax({
              type: 'POST',
              url : TesiAjax.ajax_url,
              data: {
                action: 'custom_subscribe_hb', // specify the AJAX action
                session_id: session_id,
                email: $('#mce-EMAIL').val(),
                fname: $('#mce-FNAME').val(),
                lname: $('#mce-LNAME').val(),
                company: $('#mce-COMPANY').val(),
                token: token,
                lang: lang,
                list_id: list_id,
                frequency: freq
                // tags: $("input[name=tags]").val()
              },
              dataType: 'json',
              success: function(response) {
                if (response.result === 'success') {
                    if ( response.score > 0.4 ) {
                        if ( current_language === 'en' ) {
                            window.location.href = '/en/sustainability/esg-handbook-download/?submission_hb=' + session_id;
                        } else {
                            window.location.href = '/kestavyys/esg-kasikirjan-lataus/?submission_hb=' + session_id;
                        }
                    } else {
                        $('#mce-error-response').html(response.msg).show();
                    }
                } else {
                  // handle the error
                  $('#mce-error-response').html(response.msg).show();
                }
              }
            });
        }

        window.onSubmitHB = onSubmitHB;


        function debounce(func, wait, immediate) {

            var timeout;

            return function() {

                var context = this,
                args = arguments;

                var later = function() {
                    timeout = null;
                    if (!immediate) { func.apply(context, args); }
                };

                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) { func.apply(context, args); }

            };
        }

        // $('.nostoitem--title').matchHeight();
        $('.chart__label').matchHeight();
        $('.block_txtcols--title').matchHeight();

        $("table").stupidtable();

        let lastScrollTop = 0;
        let $banner = $('.banner');
        let $wpadminbar = $('#wpadminbar');
        let topoffset = '';
        let offset = $('.mainnav').outerHeight();

        if ($wpadminbar.length > 0) {
            offset = $('.mainnav').height() - $wpadminbar.height();
            topoffset = $wpadminbar.height();
        }


        function checkScroll(e) {

            let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

            if (st > lastScrollTop) {
                // downscroll code
                $banner.addClass('going-d');
                $banner.removeClass('going-u');
                if ( $('.navbar-collapse').hasClass('show') || $('.banner__search').hasClass('show') ) {
                    $banner.css('top', '');
                } else {
                    $banner.css('top', -offset);
                }

            } else {
                // upscroll code
                $banner.removeClass('going-d');
                $banner.addClass('going-u');
                $banner.css('top', topoffset);
            }

            lastScrollTop = st <= 0 ? 0 : st;
        }
        //without debounce
        window.addEventListener("scroll", checkScroll);
        //without debounce
        // window.addEventListener("scroll", debounce(checkScroll,20,true));
        $('.nav-tabs .nav-link').on('click', function (e) {
            window.history.replaceState(null, null, '#' + $(this).attr('id'));
        });

        // $('#modal-window').on('shown.bs.modal', function (e) {
        //     $('#modal-window .nostoitem--title').matchHeight();
        // });

        $('#modal-window').on('hidden.bs.modal', function (e) {
            $('#modal-window .modal-body').html('');
        });

        $('#modal-pdf').on('hidden.bs.modal', function (e) {
            $('#modal-pdf iframe').remove();
        });


        $('main').on('click','.button--reset', function (e) {
            target = $(this).data('target');
            $(target).val('');
        });

        $('body').on('click','.openmodal', function (e) {

            e.preventDefault();

            let button = $(this);
            let modal_type = button.data('modaltype');
            let target_div = $('#modal-window .modal-body');
            let target_div_pdf = $('#modal-pdf .modal-header');
            let file_url = button.data('url');

            // console.log(modal_type);
            // console.log(button);

            if ( modal_type === 'pdf' ) {

                // console.log(file_url);

                $.ajax({
                    type: 'POST',
                    url : TesiAjax.ajax_url,
                    dataType: 'html',
                    data : {
                        action: 'populate_modal',
                        modalType: modal_type,
                        language: current_language,
                        fileUrl: file_url
                    },
                    success: function( data ) {
                        // console.log(data);
                        $(data).insertAfter(target_div_pdf);

                        $('#modal-pdf').modal('show');
                    },
                    error: function( data ) {
                        alert("An error occured: " + data.status + " " + data.statusText);
                    }
                });

            } else if ( modal_type === 'newsletter' ) {

                // const file_url = button.data('url');

                $.ajax({
                    type: 'POST',
                    url : TesiAjax.ajax_url,
                    dataType: 'html',
                    data : {
                        action: 'populate_modal',
                        modalType: modal_type,
                        language: current_language
                    },
                    success: function( data ) {
                        // console.log(data);
                        target_div.html(data);

                        $('#modal-window').modal('show');
                    },
                    error: function( data ) {
                        alert("An error occured: " + data.status + " " + data.statusText);
                    }
                });

            } else if ( modal_type === 'person' ) {

                const person_id = button.data('id');
                const person_name_html = button.siblings('.person-details-wrap').find('.person-details--name').html();
                const person_title_html = button.siblings('.person-details-wrap').find('.person-details--title').html();
                const person_phone_html = button.siblings('.person-details-wrap').find('.person-details--phone').html();
                const person_email_html = button.siblings('.person-details-wrap').find('.person-details--email').html();
                const person_linkedin_html = button.siblings('.person-details-wrap').find('.person-details--linkedin').html();
                const person_image_html = button.find('.person-details--img').html();

                let person_name = typeof person_name_html === "undefined" || !person_name_html ? '' : person_name_html;
                let person_title = typeof person_title_html === "undefined" || !person_title_html ? '' : person_title_html;
                let person_phone = typeof person_phone_html === "undefined" || !person_phone_html ? '' : person_phone_html;
                let person_email = typeof person_email_html === "undefined" || !person_email_html ? '' : person_email_html;
                let person_image = typeof person_image_html === "undefined" || !person_image_html ? '' : person_image_html;
                let person_linkedin = typeof person_linkedin_html === "undefined" || !person_linkedin_html ? '' : person_linkedin_html;


                $.ajax({
                    type: 'POST',
                    url : TesiAjax.ajax_url,
                    dataType: 'JSON',
                    data : {
                        action: 'populate_modal',
                        modalType: modal_type,
                        language: current_language,
                        personID: person_id
                    },
                    success: function( data ) {

                        // console.log(data);

                        var html =
                            '<div class="modal-person-pad">' +
                                '<div class="person-details row">' +
                                    '<div class="person-details--img col-10 col-sm-auto">' +
                                        person_image +
                                    '</div>' +
                                    '<div class="person-details-wrap col-12 col-sm-auto">' +
                                        '<h4 class="person-details--name">' + person_name + '</h4>' +
                                        '<p class="person-details--title">' + person_title + '</p>' +
                                        '<p class="person-details--phone">' + person_phone + '</p>' +
                                        '<p class="person-details--email">' + person_email + '</p>' +
                                        '<p class="person-details--linkedin">' + person_linkedin + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="person-content">' +
                                    data.content + data.companies +
                                '</div>' +
                            '</div>' +
                            '<div class="person-articles modal-person-pad">' +
                                data.articles +
                            '</div>';

                        target_div.html(html);

                        $('#modal-window').modal('show');
                    },
                    error: function( data ) {
                        alert("An error occured: " + data.status + " " + data.statusText);
                    }
                });

            } else if ( modal_type === 'company' ) {

                const company_id = button.data('id');
                const company_name = button.data('company');
                var portfolio = [];
                var toimiala = [];
                var vastuumanageri = [];
                var ensisijoitusvuosi = [];
                // const person_id = button.data('id');

                portfolio.fi = 'Portfolio';
                portfolio.en = 'Portfolio';

                toimiala.fi = 'Toimiala';
                toimiala.en = 'Industry';
                // toimiala.en = 'Industry';

                vastuumanageri.fi = 'Vastuumanageri';
                vastuumanageri.en = 'Manager';

                ensisijoitusvuosi.fi = 'Ensisijoitusvuosi';
                ensisijoitusvuosi.en = 'Investment Year';

                $.ajax({
                    type: 'POST',
                    url : TesiAjax.ajax_url,
                    dataType: 'JSON',
                    data : {
                        action: 'populate_modal',
                        modalType: modal_type,
                        language: current_language,
                        companyID: company_id
                    },
                    success: function( data ) {

                        var html =
                            '<div class="modal-company">' +
                                '<div class="company-details--img">' +
                                    data.logo +
                                '</div>' +
                                '<div class="company-details--url">' +
                                    data.url +
                                '</div>';
                            html += '<div class="row company-details--row">';

                                if ( data.portfolio.length > 0 ) {
                                    html += '<div class="col-auto col-lg-4">' +
                                        '<strong>' + portfolio[current_language] + '</strong><br>' +
                                        data.portfolio +
                                    '</div>';
                                }

                                if ( data.toimiala.length > 0 ) {
                                    html += '<div class="col-auto col-lg-4">' +
                                        '<strong>' + toimiala[current_language] + '</strong><br>' +
                                        data.toimiala +
                                    '</div>';
                                }

                                if ( data.vastuumanageri.length > 0 ) {
                                    html += '<div class="col-auto col-lg-4">' +
                                        '<strong>' + vastuumanageri[current_language] + '</strong><br>' +
                                        data.vastuumanageri +
                                    '</div>';
                                }

                                if ( data.ensisijoitusvuosi.length > 0 ) {
                                    html += '<div class="col-auto col-lg-4">' +
                                        '<strong>' + ensisijoitusvuosi[current_language] + '</strong><br>' +
                                        data.ensisijoitusvuosi +
                                    '</div>';
                                }

                                html += '</div>' +
                                '<div class="company-details--desc">' +
                                    data.content +
                                '</div>' +
                                '<div class="company-details--articles">' +
                                    data.articles +
                                '</div>' +
                            '</div>';

                        target_div.html(html);

                        $('#modal-window').modal('show');
                    },
                    error: function( data ) {
                        alert("An error occured: " + data.status + " " + data.statusText);
                    }
                });

            } else if ( modal_type === 'mediaitem' ) {

                let target_div = $('#modal-media .modal-body');

                const mediaitem_id = button.data('id');
                const mediaitem_name = button.data('mediaitem');

                $.ajax({
                    type: 'POST',
                    url : TesiAjax.ajax_url,
                    dataType: 'JSON',
                    data : {
                        action: 'populate_modal',
                        modalType: modal_type,
                        language: current_language,
                        mediaitemID: mediaitem_id
                    },
                    success: function( data ) {

                        var html =
                            '<div class="modal-mediaitem">' +
                                data.modalcontent +
                            '</div>';

                        target_div.html(html);

                        $('#modal-media').modal('show');
                    },
                    error: function( data ) {
                        alert("An error occured: " + data.status + " " + data.statusText);
                    }
                });

            }

        });

        // runs animation before hash change, when link is clicked
        $(document).on('click', 'a[href*="#"]', function (e) {

            var parser = document.createElement('a'), hash;
            parser.href = $(this).attr('href');

            hash = parser.hash;

            // if it links to a different page, don't animate
            if (window.location.protocol !== parser.protocol ||
                    window.location.host !== parser.host ||
                    window.location.pathname !== parser.pathname ||
                    window.location.search !== parser.search) {
                return true;
            }

            e.preventDefault();

            $('html, body').animate({
                scrollTop: $(hash).offset().top - 100
            }, 800);

        });

        $(document).on('click', 'a.anchor', function (event) {

            event.preventDefault();

            hrefval = $.attr(this, 'href');
            $('html, body').animate({
                scrollTop: $(hrefval).offset().top - 40
            }, 800);

            history.pushState(null, null, hrefval);

        });

        $('.slides').on('init', function(event, slick){
              var firstSlide = $('.slides .slick-slide[data-slick-index="0"]');
              var firstSlideData = firstSlide.find('.slide').data('color');
              $('.slick-arrow').removeClass('text-white text-blue');
              $('.slick-arrow').addClass(firstSlideData);
              $('.slick-dots').removeClass('text-white text-blue');
              $('.slick-dots').addClass(firstSlideData);
        });

        if ($('.slides').length) {
          $('.slides').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: true,
            fade: true,
            speed: 700,
            // infinite: false,
            dots: true,
            appendDots: $('.slick-dots-wrap-init'),
            pauseOnHover: false,
            lazyLoad: 'ondemand',
            waitForAnimate: true,
            prevArrow: $('.slider-nav .slick-prev'),
            nextArrow: $('.slider-nav .slick-next')
          });

          $('.slides').on('beforeChange', function(event, slick, currentSlide, nextSlide){
                // Get the color for the next slide
                var activeSlide = $('.slides .slick-slide.slick-active');
                var nextSlideDiv = $('.slides .slick-slide[data-slick-index="' + nextSlide + '"]');
                var nextSlideData = nextSlideDiv.find('.slide').data('color');
                var nextSlideDots = nextSlideDiv.find('.slick-dots-wrap');
                activeSlide.find('.slick-dots-wrap .slick-dots').appendTo(nextSlideDots);
                $('.slick-arrow').removeClass('text-white text-blue text-orange');
                $('.slick-arrow').addClass(nextSlideData);
                $('.slick-dots').removeClass('text-white text-blue text-orange');
                $('.slick-dots').addClass(nextSlideData);
          });
        }



        if ($('.timeslides').length) {

          $('.timeslides').slick({
            autoplay: false,
            autoplaySpeed: 5000,
            adaptiveHeight: true,
            arrows: true,
            fade: false,
            speed: 700,
            infinite: false,
            dots: true,
            appendDots: $('.slick-dots-wrap-init'),
            pauseOnHover: true,
            lazyLoad: 'ondemand',
            waitForAnimate: true,
            prevArrow: $('.slider-nav .slick-prev'),
            nextArrow: $('.slider-nav .slick-next'),
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992, // tablet breakpoint
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 768, // tablet breakpoint
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                // {
                //     breakpoint: 560, // mobile breakpoint
                //     settings: {
                //         slidesToShow: 1,
                //         slidesToScroll: 1
                //     }
                // }
            ]

          });

        }
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'page_template_template_page_ajankohtaista': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {

        const hash = window.location.hash.substr(1);
        const current_url = window.location;

        let current_language = document.documentElement.lang;

        if (current_language === 'en-GB') {
            current_language = 'en';
        }

        $(document).on('click', '#toggle-years', function(e) {

            e.preventDefault();

            $('#years-wrap').fadeToggle();

        });

        $(document).on('click', '.latest-filter', function(e) {

            var yearsFilter = [];
            var postTypes = [];
            var tesiTags = [];
            var yearsParam = '';
            var postParam = '';
            var tagsParam = '';
            var viewParam = '';
            var filtersTrue = '';
            var filterNonce = $('#filterForm').attr('data-nonce');
            var filterTarget = $('#filter-target');
            var viewCount = $('.nostoitem').length;

            $('.load-more').addClass('hidden');
            filterTarget.addClass('hidden');
            filterTarget.siblings('.return-content').remove();
            $('.spinner-container').show();
            $('.tesi-filters-disable').show();

            if (e.target.nodeName === 'DIV') {
                $(this).toggleClass('active');
            }

            $("input[name='years[]']:checked").each(function () {
              yearsFilter.push($(this).val());
            });

            $("input[name='posttypes[]']:checked").each(function () {
              postTypes.push($(this).val());
            });

            $("div.latest-filter.active").each(function () {
              tesiTags.push($(this).data('termid'));
            });

            if ( yearsFilter.length > 0 ) {
                yearsParam = '&years=' + yearsFilter;
            }

            if ( postTypes.length > 0 ) {
                postParam = '&types=' + postTypes;
            }

            if ( tesiTags.length > 0 ) {
                tagsParam = '&tags=' + tesiTags;
            }

            if ( viewCount > 0 ) {
                viewParam = '&total=' + viewCount;
            }

            if ( yearsFilter.length > 0 || viewCount > 0 || postTypes.length > 0 || tesiTags.length > 0 ) {
                filtersTrue = '?filters=1';
            }

            window.history.replaceState(null, null, filtersTrue + yearsParam + postParam + tagsParam + viewParam);

            $.ajax({
              type: 'POST',
              url: TesiAjax.ajax_url,
              data: {
                action: 'filter_articles',
                yearsFilter: yearsFilter,
                postTypes: postTypes,
                tesiTags: tesiTags,
                language: current_language,
                // nonce: filterNonce,
              },
              success: function( data ) {

                setTimeout(function(){

                    var $posts = data.content;

                    $('.loaded-content').each(function () {
                        $(this).remove();
                    });

                    if ( $posts === '' ) {

                        if ( current_language === 'fi' ) {
                            $(filterTarget).html('<div class="text-center">Ei hakuehtoja vastaavia tuloksia.</div>');
                        } else {
                            $(filterTarget).html('<div class="text-center">No matching results.</div>');
                        }


                    } else {

                        $(filterTarget).html(data.content);

                        if (data.posts_left === 0) {
                            $('.load-more').addClass('hidden');
                        } else {
                            $('.posts-left').html(' (' + data.posts_left + ')');
                            $('.load-more').removeClass('hidden');
                        }

                    }

                    $('.tesi-filters-disable').hide();
                    filterTarget.removeClass('hidden');
                    $('.spinner-container').hide();

                    // $('.nostoitem--title').matchHeight();

                }, 1000);

              },
              error: function( data ) {
                alert("An error occured: " + data.status + " " + data.statusText);
              }
            });

        });

        $(document).on('click', '.load-more', function(e) {

            e.preventDefault();

            var yearsFilter = [];
            var excludedPosts = [];
            var postTypes = [];
            var tesiTags = [];
            var $button = $(this);
            var yearsParam = '';
            var postParam = '';
            var tagsParam = '';
            var viewParam = '';
            var filtersTrue = '';


            $(".nostoitem").each(function () {
              excludedPosts.push($(this).data('itemid'));
            });

            $("input[name='years[]']:checked").each(function () {
              yearsFilter.push($(this).val());
            });

            $("input[name='posttypes[]']:checked").each(function () {
              postTypes.push($(this).val());
            });

            $("div.latest-filter.active").each(function () {
              tesiTags.push($(this).data('termid'));
            });

            // console.log(excludedPosts);

            $.ajax({
              type: 'POST',
              url: TesiAjax.ajax_url,
              data: {
                action: 'filter_articles',
                yearsFilter: yearsFilter,
                postTypes: postTypes,
                tesiTags: tesiTags,
                excludedPosts: excludedPosts,
                language: current_language
              },
              success: function( data ) {

                $(data.content).insertAfter($button);

                if (data.posts_left === 0) {
                    $button.hide();
                } else {
                    $('.posts-left').html(' (' + data.posts_left + ')');
                    $button.show().insertAfter($button.next());
                }

                var viewCount = $('.nostoitem').length;

                if ( yearsFilter.length > 0 ) {
                    yearsParam = '&years=' + yearsFilter;
                }

                if ( postTypes.length > 0 ) {
                    postParam = '&types=' + postTypes;
                }

                if ( tesiTags.length > 0 ) {
                    tagsParam = '&tags=' + tesiTags;
                }

                if ( viewCount > 0 ) {
                    viewParam = '&total=' + viewCount;
                }

                if ( yearsFilter.length > 0 || viewCount > 0 || postTypes.length > 0 || tesiTags.length > 0 ) {
                    filtersTrue = '?filters=1';
                }

                window.history.replaceState(null, null, filtersTrue + yearsParam + postParam + tagsParam + viewParam );

                // $('.nostoitem--title').matchHeight();

              },
              error: function( data ) {
                alert("An error occured: " + data.status + " " + data.statusText);
              }
            });

        });

      }
    },
    'search_results': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {

        let current_language = document.documentElement.lang;

        if (current_language === 'en-GB') {
            current_language = 'en';
        }

        $(document).on( 'submit', '#site-search', function() {

            var $form = $(this),
                $input = $('#s'),
                query = $input.val(),
                postTypes = [],
                years = [],
                $filterTarget = $('#filter-target');

                // console.log(current_language);

            $('.load-more').addClass('hidden');
            $filterTarget.addClass('hidden');
            $('#more-target').html('');
            $('.spinner-container').show();
            $('.tesi-filters-disable').show();

            $("input[name='posttypes[]']:checked").each(function () {
                postTypes.push($(this).val());
            });

            $("input[name='years[]']:checked").each(function () {
                years.push($(this).val());
            });

            if (current_language === 'fi') {
                window.history.replaceState(null, null, '/search/' + query );
            } else if (current_language === 'en') {
                window.history.replaceState(null, null, '/en/search/' + query );
            }

            $.ajax({
                type: 'POST',
                url: TesiAjax.ajax_url,
                data: {
                    action: 'load_search_results',
                    postTypes: postTypes,
                    years: years,
                    language: current_language,
                    query: query
                    // nonce: filterNonce,
                },
                success: function( data ) {

                    setTimeout(function(){

                        var $posts = data.content;

                        // console.log(data.query);
                        // console.log(data.post_types);
                        // console.log(data.post_count);
                        // console.log(data.posts_left);
                        // console.log(data.lang);

                        $('.loaded-content').each(function () {
                            $(this).remove();
                        });

                        if ( $posts === '' ) {

                            if ( current_language === 'fi' ) {
                                $filterTarget.html('<div class="text-center">Ei hakuehtoja vastaavia tuloksia.</div>');
                            } else {
                                $filterTarget.html('<div class="text-center">No matching results.</div>');
                            }

                        } else {

                            $filterTarget.html(data.content);

                            if (data.posts_left === 0) {
                                $('.load-more').addClass('hidden');
                            } else {
                                $('.posts-left').html(' (' + data.posts_left + ')');
                                $('.load-more').removeClass('hidden');
                            }

                        }

                        $('.tesi-filters-disable').hide();
                        $filterTarget.removeClass('hidden');
                        $('.spinner-container').hide();

                    }, 500);

                },
                error: function( data ) {
                    alert("An error occured: " + data.status + " " + data.statusText);
                }

            });

            return false;

        });

        $(document).on('click', '.search-filter', function(e) {

            var $input = $('#s'),
                query = $input.val(),
                postTypes = [],
                years = [],
                $filterTarget = $('#filter-target');

            $filterTarget.addClass('hidden');
            $('#more-target').html('');
            $('.spinner-container').show();
            $('.tesi-filters-disable').show();
            $('.load-more').addClass('hidden');

            $("input[name='posttypes[]']:checked").each(function () {
                postTypes.push($(this).val());
            });

            $("input[name='years[]']:checked").each(function () {
                years.push($(this).val());
            });

            // console.log(years);

            $.ajax({
                type: 'POST',
                url: TesiAjax.ajax_url,
                data: {
                    action: 'load_search_results',
                    postTypes: postTypes,
                    years: years,
                    language: current_language,
                    query: query
                    // nonce: filterNonce,
                },
                success: function( data ) {

                    setTimeout(function() {

                        // console.log(data.posts_left);

                        var $posts = data.content;

                        $('.loaded-content').each(function () {
                            $(this).remove();
                        });

                        if ( $posts === '' ) {

                            if ( current_language === 'fi' ) {
                                $filterTarget.html('<div class="text-center">Ei hakuehtoja vastaavia tuloksia.</div>');
                            } else {
                                $filterTarget.html('<div class="text-center">No matching results.</div>');
                            }

                        } else {

                            $filterTarget.html(data.content);

                            if (data.posts_left === 0) {
                                $('.load-more').addClass('hidden');
                            } else {
                                $('.posts-left').html(' (' + data.posts_left + ')');
                                $('.load-more').removeClass('hidden');
                            }

                        }

                        $('.tesi-filters-disable').hide();
                        $filterTarget.removeClass('hidden');
                        $('.spinner-container').hide();

                    }, 500);

                },
                error: function( data ) {
                    alert("An error occured: " + data.status + " " + data.statusText);
                }

            });

        });

        $(document).on('click', '.load-more', function(e) {

            e.preventDefault();

            var $button = $(this),
                $input = $('#s'),
                query = $input.val(),
                excludedPosts = [],
                postTypes = [],
                $filterTarget = $('#filter-target'),
                $moreTarget = $('#more-target'),
                $spinner = $('.search-spinner'),
                years = [];

            $(".nostoitem").each(function () {
              excludedPosts.push($(this).data('itemid'));
            });

            $("input[name='posttypes[]']:checked").each(function () {
              postTypes.push($(this).val());
            });

            $("input[name='years[]']:checked").each(function () {
              years.push($(this).val());
            });

            $(".loaded-content").removeClass('loaded-content');

            // console.log(excludedPosts);

            $.ajax({
                type: 'POST',
                url: TesiAjax.ajax_url,
                data: {
                    action: 'load_search_results',
                    postTypes: postTypes,
                    years: years,
                    excludedPosts: excludedPosts,
                    language: current_language,
                    query: query
                },
                beforeSend: function() {
                    $button.addClass('hidden');
                    $spinner.fadeIn();
                },
                success: function( data ) {

                    $spinner.hide();
                    $moreTarget.append(data.content);
                    // $(data.content).insertBefore($button);

                    if (data.posts_left === 0) {
                        $button.addClass('hidden');
                    } else {
                        $('.posts-left').html(' (' + data.posts_left + ')');
                        $button.removeClass('hidden').insertAfter($moreTarget);
                        $spinner.insertAfter($moreTarget);
                    }

                    // $('.nostoitem--title').matchHeight();
                },
                error: function( data ) {
                    alert("An error occured: " + data.status + " " + data.statusText);
                 }
            });

        });

      }
    },
    'page_template_template_page_documents': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {

        const hash = window.location.hash.substr(1);
        const current_url = window.location;

        let current_language = document.documentElement.lang;

        if (current_language === 'en-GB') {
            current_language = 'en';
        }

        $(document).on('click', '.document-filter', function(e) {

            var yearsFilter = [];
            var tesiTags = [];
            var yearsParam = '';
            var tagsParam = '';
            var viewParam = '';
            var filtersTrue = '';
            var filterNonce = $('#filterForm').attr('data-nonce');
            var filterTarget = $('#filter-target');
            var viewCount = $('.nostoitem').length;

            $('.load-more').addClass('hidden');
            filterTarget.addClass('hidden');
            filterTarget.siblings('.return-content').remove();
            $('.spinner-container').show();
            $('.tesi-filters-disable').show();

            if (e.target.nodeName === 'DIV') {
                $(this).toggleClass('active');
            }

            $("input[name='years[]']:checked").each(function () {
              yearsFilter.push($(this).val());
            });

            $("div.document-filter.active").each(function () {
              tesiTags.push($(this).data('termid'));
            });

            if ( yearsFilter.length > 0 ) {
                yearsParam = '&years=' + yearsFilter;
            }

            if ( tesiTags.length > 0 ) {
                tagsParam = '&tags=' + tesiTags;
            }

            if ( viewCount > 0 ) {
                viewParam = '&total=' + viewCount;
            }

            if ( yearsFilter.length > 0 || viewCount > 0 || tesiTags.length > 0 ) {
                filtersTrue = '?filters=1';
            }

            window.history.replaceState(null, null, filtersTrue + yearsParam + tagsParam + viewParam);

            // console.log(yearsFilter);

            $.ajax({
              type: 'POST',
              url: TesiAjax.ajax_url,
              data: {
                action: 'filter_documents',
                yearsFilter: yearsFilter,
                tesiTags: tesiTags,
                language: current_language,
                // nonce: filterNonce,
              },
              success: function( data ) {

                setTimeout(function(){

                    var $posts = data.content;

                    $('.loaded-content').each(function () {
                        $(this).remove();
                    });

                    if ( $posts === '' ) {

                        if ( current_language === 'fi' ) {
                            $(filterTarget).html('<div class="text-center">Ei hakuehtoja vastaavia tuloksia.</div>');
                        } else {
                            $(filterTarget).html('<div class="text-center">No matching results.</div>');
                        }


                    } else {

                        $(filterTarget).html(data.content);

                        if (data.posts_left === 0) {
                            $('.load-more').addClass('hidden');
                        } else {
                            $('.posts-left').html(' (' + data.posts_left + ')');
                            $('.load-more').removeClass('hidden');
                        }

                    }

                    $('.tesi-filters-disable').hide();
                    filterTarget.removeClass('hidden');
                    $('.spinner-container').hide();

                    // $('.nostoitem--title').matchHeight();

                }, 1000);

              },
              error: function( data ) {
                alert("An error occured: " + data.status + " " + data.statusText);
              }
            });

        });

        $(document).on('click', '.load-more', function(e) {

            e.preventDefault();

            var yearsFilter = [];
            var excludedPosts = [];
            var postTypes = ['document'];
            var tesiTags = [];
            var $button = $(this);
            var yearsParam = '';
            var postParam = '';
            var tagsParam = '';
            var viewParam = '';
            var filtersTrue = '';

            $(".nostoitem").each(function () {
              excludedPosts.push($(this).data('itemid'));
            });

            $("input[name='years[]']:checked").each(function () {
              yearsFilter.push($(this).val());
            });

            $("div.document-filter.active").each(function () {
              tesiTags.push($(this).data('termid'));
            });

            $.ajax({
              type: 'POST',
              url: TesiAjax.ajax_url,
              data: {
                action: 'filter_documents',
                yearsFilter: yearsFilter,
                postTypes: postTypes,
                tesiTags: tesiTags,
                excludedPosts: excludedPosts,
                language: current_language,
              },
              success: function( data ) {

                $(data.content).insertAfter($button);

                if (data.posts_left === 0) {
                    $button.addClass('hidden');
                } else {
                    $('.posts-left').html(' (' + data.posts_left + ')');
                    $button.removeClass('hidden').insertAfter($button.next());
                }

                var viewCount = $('.nostoitem').length;

                if ( yearsFilter.length > 0 ) {
                    yearsParam = '&years=' + yearsFilter;
                }

                if ( tesiTags.length > 0 ) {
                    tagsParam = '&tags=' + tesiTags;
                }

                if ( viewCount > 0 ) {
                    viewParam = '&total=' + viewCount;
                }

                if ( yearsFilter.length > 0 || viewCount > 0 || tesiTags.length > 0 ) {
                    filtersTrue = '?filters=1';
                }

                window.history.replaceState(null, null, filtersTrue + yearsParam + tagsParam + viewParam );

                // $('.nostoitem--title').matchHeight();

              },
              error: function( data ) {
                alert("An error occured: " + data.status + " " + data.statusText);
              }
            });

        });

      }
    },
    'page_template_template_page_portfolio_company': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {

        const hash = window.location.hash.substr(1);
        const current_url = window.location;

        let current_language = document.documentElement.lang;

        if (current_language === 'en-GB') {
            current_language = 'en';
        }

        var hashNavLink = $('.nav-link[id="'+hash+'"]');

        if ( hashNavLink.length ) {
            $('.nav-link').removeClass('active');
            hashNavLink.addClass('active');
            target_tab = hashNavLink.attr('href');

            // console.log(target_tab);
            $('.tab-pane').removeClass('show active');
            $(target_tab).addClass('show active');
        }

        $('.portfolio-company--wrap').matchHeight({byRow: false});

    // Function to update filters and display
    function updateFilters() {
        var portfolioIDs = [];
        var industryIDs = [];
        var $newhash = '#' + $('.nav-tabs .nav-item:first-child').find('.nav-link').attr('id');

        // Get selected portfolios
        $("input[name='portfolios[]']:checked").each(function() {
            portfolioIDs.push($(this).val());
        });

        // Get selected industries
        $("input[name='industries[]']:checked").each(function() {
            industryIDs.push($(this).val());
        });

        // Update URL
        var queryParams = [];
        if (portfolioIDs.length > 0) {
            queryParams.push('portfolios=' + portfolioIDs);
        }
        if (industryIDs.length > 0) {
            queryParams.push('industries=' + industryIDs);
        }

        var queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : '';
        window.history.replaceState(null, null, queryString + $newhash);

        // Process companies based on selected filters
        $('.portfolio-company').each(function() {
            var company_div = $(this);
            var companyPortfolios = company_div.data('portfolios');
            var companyIndustries = company_div.data('industries');

            // Reset classes
            company_div.removeClass('active');
            company_div.removeClass('nohit');

            // If no filters are selected, show all companies
            if (portfolioIDs.length === 0 && industryIDs.length === 0) {
                company_div.addClass('active');
                return;
            }

            var shouldShow = false;

            // Check if company matches any selected portfolio
            if (portfolioIDs.length > 0) {
                for (var i = 0; i < portfolioIDs.length; i++) {
                    if ($.inArray(portfolioIDs[i], companyPortfolios) !== -1) {
                        shouldShow = true;
                        break;
                    }
                }
            }

            // Check if company matches any selected industry
            if (industryIDs.length > 0) {
                for (var j = 0; j < industryIDs.length; j++) {
                    if ($.inArray(industryIDs[j], companyIndustries) !== -1) {
                        shouldShow = true;
                        break;
                    }
                }
            }

            // If company matches any of the selected filters, show it
            if (shouldShow) {
                company_div.addClass('active');
            }
        });

        // Ensure all checkboxes remain enabled
        $('.industry-filter').each(function() {
            $(this).removeAttr("disabled");
        });

        $('.portfolio-filter').each(function() {
            $(this).removeAttr("disabled");
        });
    }

    // Event handler for portfolio filter changes
    $(document).on('click', '.portfolio-filter', function(e) {
        // Clear search
        $('#companysearch').val('');
        updateFilters();
    });

    // Event handler for industry filter changes
    $(document).on('click', '.industry-filter', function(e) {
        // Clear search
        $('#companysearch').val('');
        updateFilters();
    });

    // Initialize filters on page load
    updateFilters();

        $(document).on('click', '.toggle-list', function(e) {

            e.preventDefault();

            $(this).hide();
            $('.company-grid').hide();
            $('.company-table').show();
            $('.toggle-grid').show();

        });

        $(document).on('click', '.toggle-grid', function(e) {

            e.preventDefault();

            $(this).hide();
            $('.company-table').hide();
            $('.company-grid').show();
            $('.toggle-list').show();

        });

        function delay(callback, ms) {
          var timer = 0;
          return function() {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
              callback.apply(context, args);
            }, ms || 0);
          };
        }

        // search & highlight
        var $company_container = $( '.company-container' );

        if( $company_container.length > 0 ) {

            var $companyinput = $( '#companysearch' );
            itemsIndexed      = [];
            $item             = $();

            $companyinput.on('focus', function(){
                // $notfound       = $company_container.find( '.company-notfound' ),
                $companyinput.val('');
                itemsIndexed = [];

                $items = $company_container.find( '.portfolio-company.active' );

                $items.each( function() {
                    itemsIndexed.push( $( this ).text().replace( /\s{2,}/g, ' ' ).toLowerCase() );
                    $items.removeClass( 'nohit' );
                    $items.removeClass( 'hit' );
                });

            });

            $companyinput.bind("mouseup", function(e){

                var oldValue = $companyinput.val();

                if (oldValue === "") {
                    return;
                }

                // When this event is fired after clicking on the clear button
                // the value is not cleared yet. We have to wait for it.
                setTimeout(function(){
                    var newValue = $companyinput.val();

                    if (newValue === ""){
                        $items.removeClass( 'nohit' );
                        $items.addClass( 'hit' );
                    }
                }, 1);

            });

            $companyinput.on( 'keyup', function( e ) {

                var searchVal = $.trim( $companyinput.val() ).toLowerCase();

                if( e.keyCode === 13 ) { // enter
                    $companyinput.trigger( 'blur' );
                    return;
                }

                $solo_item = $items.not(':hidden');

                if( $solo_item.length === 1 ) {
                    $solo_item.removeClass( 'nohit' );
                    $solo_item.addClass( 'hit' );
                }

                // $items.each( function() {
                //     $item = $( this );
                //     $item.html( $item.html().replace( /<span class="highlight">([^<]+)<\/span>/gi, '$1' ) );
                // });

                if( searchVal.length > 1 ) {

                    for( var i in itemsIndexed ) {

                        $item = $items.eq( i );

                        if( itemsIndexed[ i ].indexOf( searchVal ) !== -1 ) {
                            $item.removeClass( 'nohit' );
                            $item.addClass( 'hit' );
                        } else if (itemsIndexed[ i ].indexOf( searchVal.substring(0, 5) ) !== -1) {
                            $item.removeClass( 'nohit' );
                            $item.addClass( 'hit' );
                        } else {
                            $item.removeClass( 'hit' );
                            $item.addClass( 'nohit' );
                        }
                    }

                } else {
                    $items.removeClass( 'nohit' );
                    $items.addClass( 'hit' );
                }

            });

            // $companyinput.on( 'keyup', delay(function (e) {

            //     if ( $items.not(':hidden').length === 0 ) {

            //         var searchVal = $.trim( $companyinput.val() ).toLowerCase();

            //         // console.log(searchVal);

            //         if( searchVal.length > 5 ) {

            //             dataLayer.push({
            //               'event': 'company-not-found',
            //               'search-string': searchVal
            //             });

            //         }

            //     }

            // }, 3000));

        }

      }
    },
    'page_template_template_page_portfolio_fund': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {

        const hash = window.location.hash.substr(1);
        const current_url = window.location;

        let current_language = document.documentElement.lang;

        if (current_language === 'en-GB') {
            current_language = 'en';
        }

        var hashNavLink = $('.nav-link[id="'+hash+'"]');

        if ( hashNavLink.length ) {
            $('.nav-link').removeClass('active');
            hashNavLink.addClass('active');
            target_tab = hashNavLink.attr('href');

            // console.log(target_tab);
            $('.tab-pane').removeClass('show active');
            $(target_tab).addClass('show active');
        }

        $(document).on('click', '.portfolio-filter', function(e) {

            $('.class-filter').prop('checked', false);

            var investorIDs = [];
            var classIDs = [];
            var fundClasses = [];
            var currentInvestorID = $(this).val();

            if ( $(this).data('isparent') ) {
                if ( $(this).prop('checked') === false ) {
                    $("input[data-parent='" + currentInvestorID + "'").each(function () {
                        $(this).prop('checked', false);
                    });
                } else {
                    $("input[data-parent='" + currentInvestorID + "'").each(function () {
                        $(this).prop('checked', true);
                    });
                }
            }

            $('#fundsearch').val('');

            $("input[name='classes[]']:checked").each(function () {
                classIDs.push($(this).val());
            });

            if ( $(this).data('parent') ) {

                parent_id = parseInt($(this).data('parent'));

                $("input[name='investors[]']:checked").each(function () {
                    if (parseInt($(this).val()) !== parent_id) {
                        investorIDs.push($(this).val());
                    }
                });

                if ( $("input[data-parent='" + parent_id + "'").not(':checked').length > 0 ) {
                    $("input[data-isparent]").val(parent_id).prop('checked', false);
                } else {
                    $("input[data-isparent]").val(parent_id).prop('checked', true);
                }

            } else {
                $("input[name='investors[]']:checked").each(function () {
                    investorIDs.push($(this).val());
                });
            }

            // console.log(investorIDs);

            $newhash = '#' + $('.nav-tabs .nav-item:first-child').find('.nav-link').attr('id');
            window.history.replaceState(null, null, '?investors=' + investorIDs + $newhash );

            // console.log(portfolioIDs);
            // console.log(industryIDs);

            $('.portfolio-fund').each(function() {

                var fund_row = $(this);
                var fundInvestors = fund_row.data('investors');
                var fundClasses = fund_row.data('classes');

                fund_row.removeClass('active');
                fund_row.removeClass('nohit');

                // console.log(portfolioIDs);
                // console.log(companyPortfolios);

                if (investorIDs.length > 0 && fundInvestors.length > 0) {
                    var uq1 = $.grep(investorIDs, function(element) {
                        if ($.inArray(element, fundInvestors) !== -1) {
                            // console.log(element);
                            fund_row.addClass('active');
                        }
                        // else {
                            // $company_div.removeClass('active');
                        // }
                    });
                }

                // if (industryIDs.length && companyIndustries.length ) {
                //     var uniqueInd = $.grep(companyIndustries, function(element) {
                //         if ($.inArray(element, industryIDs) !== -1) {
                //             company_div.addClass('active');
                //         }
                //     });
                // }

                // if ($.inArray(, matching) != -1) {
                //     $(this).hide();
                //     // something_matches = true;
                // }
            });

            var activeClassIDs = [];

            $('.portfolio-fund.active').each(function() {

                var fundClasses = $(this).data('classes');

                activeClassIDs = $.merge($.merge([], activeClassIDs), fundClasses);

            });

            activeClassIDs = $.unique(activeClassIDs);

            $('.class-filter').each(function() {

                var classID = $(this).val();

                if ($.inArray(classID, activeClassIDs) === -1) {
                    $(this).removeClass('active');
                    $(this).attr("disabled", true);
                    $(this).prop("checked", false);
                } else {
                    $(this).addClass('active');
                    $(this).removeAttr("disabled");
                    // $(this).prop("checked", false);
                }

            });



        });

        $(document).on('click', '.class-filter', function(e) {

            $('.class-filter').not(this).prop('checked', false);

            var investorIDs = [];
            var classIDs = [];

            $("input[name='investors[]']:checked").each(function () {
              investorIDs.push($(this).val());
            });

            $("input[name='classes[]']:checked").each(function () {
              classIDs.push($(this).val());
            });

            // console.log(investorIDs);
            // console.log(classIDs);

            $newhash = '#' + $('.nav-tabs .nav-item:first-child').find('.nav-link').attr('id');
            window.history.replaceState(null, null, '?investors=' + investorIDs + '&classes=' + classIDs + $newhash );

            $('.portfolio-fund').each(function() {

                var fund_row = $(this);
                var fundInvestors = fund_row.data('investors');
                var fundClasses = fund_row.data('classes');

                fund_row.removeClass('nohit');
                $('#fundsearch').val('');

                if (investorIDs.length > 0 && classIDs.length > 0) {

                    if (fund_row.hasClass('active')) {

                        if (classIDs.length > 0 && fundClasses.length > 0 ) {
                            var uq2 = $.grep(classIDs, function(element) {
                                if ($.inArray(element, fundClasses) !== -1) {
                                    fund_row.addClass('active');
                                } else {
                                    fund_row.removeClass('active');
                                }
                            });
                        } else {
                            fund_row.removeClass('active');
                        }

                    } else {

                        if (fundInvestors.length > 0) {
                            var uq3 = $.grep(investorIDs, function(element) {
                                if ($.inArray(element, fundInvestors) !== -1) {
                                    // console.log(element);

                                    if (classIDs.length > 0 && fundClasses.length > 0 ) {
                                        var uq2 = $.grep(classIDs, function(element) {
                                            if ($.inArray(element, fundClasses) !== -1) {
                                                fund_row.addClass('active');
                                            } else {
                                                fund_row.removeClass('active');
                                            }
                                        });

                                    }

                                }
                            });
                        }

                    }

                } else if (investorIDs.length > 0 && classIDs.length === 0) {

                    fund_row.removeClass('active');

                    var uq7 = $.grep(investorIDs, function(element) {
                        if ($.inArray(element, fundInvestors) !== -1) {
                            fund_row.addClass('active');
                        }
                    });

                }

            });

        });

        function delay(callback, ms) {
          var timer = 0;
          return function() {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
              callback.apply(context, args);
            }, ms || 0);
          };
        }

        // search & highlight
        var $fund_container = $( '.fund-container' );

        if( $fund_container.length > 0 ) {

            var $fundinput    = $( '#fundsearch' );
            $item             = $();
            itemsIndexed  = [];

            $fundinput.on('focus', function(){
                // $notfound       = $company_container.find( '.company-notfound' ),
                $fundinput.val('');
                itemsIndexed  = [];

                $items = $fund_container.find( '.portfolio-fund.active' );

                $items.each( function() {
                    itemsIndexed.push( $( this ).text().replace( /\s{2,}/g, ' ' ).toLowerCase() );
                    $items.removeClass( 'nohit' );
                    $items.removeClass( 'hit' );
                });

                // console.log(itemsIndexed);

            });

            $fundinput.bind("mouseup", function(e){

                var oldValue = $fundinput.val();

                if (oldValue === "") {
                    return;
                }

                // When this event is fired after clicking on the clear button
                // the value is not cleared yet. We have to wait for it.
                setTimeout(function(){
                    var newValue = $fundinput.val();

                    if (newValue === ""){
                        $items.removeClass( 'nohit' );
                        $items.addClass( 'hit' );
                    }
                }, 1);

            });

            $fundinput.on( 'keyup', function( e ) {

                var searchVal = $.trim( $fundinput.val() ).toLowerCase();

                if( e.keyCode === 13 ) { // enter
                    $fundinput.trigger( 'blur' );
                    return;
                }

                $solo_item = $items.not(':hidden');

                if( $solo_item.length === 1 ) {
                    $solo_item.removeClass( 'nohit' );
                    $solo_item.addClass( 'hit' );
                }

                // $items.each( function() {
                //     $item = $( this );
                //     $item.html( $item.html().replace( /<span class="highlight">([^<]+)<\/span>/gi, '$1' ) );
                // });

                if( searchVal.length > 1 ) {

                    for( var i in itemsIndexed ) {

                        $item = $items.eq( i );

                        if( itemsIndexed[ i ].indexOf( searchVal ) !== -1 ) {
                            $item.removeClass( 'nohit' );
                            $item.addClass( 'hit' );
                        } else if (itemsIndexed[ i ].indexOf( searchVal.substring(0, 5) ) !== -1) {
                            $item.removeClass( 'nohit' );
                            $item.addClass( 'hit' );
                        } else {
                            $item.removeClass( 'hit' );
                            $item.addClass( 'nohit' );
                        }
                    }

                } else {
                    $items.removeClass( 'nohit' );
                    $items.addClass( 'hit' );
                }

            });

            // $companyinput.on( 'keyup', delay(function (e) {

            //     if ( $items.not(':hidden').length === 0 ) {

            //         var searchVal = $.trim( $companyinput.val() ).toLowerCase();

            //         // console.log(searchVal);

            //         if( searchVal.length > 5 ) {

            //             dataLayer.push({
            //               'event': 'company-not-found',
            //               'search-string': searchVal
            //             });

            //         }

            //     }

            // }, 3000));

        }

      }
    },
    'page_template_template_page_markkinatieto': {
      init: function() {
        // JavaScript to be fired on the about us page
      },
      finalize: function() {

        if ($('.docslides').length) {

          $('.docslides').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            adaptiveHeight: true,
            arrows: true,
            fade: false,
            speed: 700,
            // infinite: false,
            dots: true,
            appendDots: $('.slick-dots-wrap-init'),
            pauseOnHover: true,
            lazyLoad: 'ondemand',
            waitForAnimate: true,
            prevArrow: $('.slider-nav .slick-prev'),
            nextArrow: $('.slider-nav .slick-next'),
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992, // tablet breakpoint
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 768, // tablet breakpoint
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                // {
                //     breakpoint: 560, // mobile breakpoint
                //     settings: {
                //         slidesToShow: 1,
                //         slidesToScroll: 1
                //     }
                // }
            ]

          });

        }

      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Basetheme;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
